import {
  TOGGLE_DASHBOARD_SHOULD_REFRESH,
  TOGGLE_DASHBOARD_LOADING,
} from "../actions/dashboard";
import genObj from "../../lib/genObj";

const initialState = {
  shouldRefresh: false,
  loading: true,
};

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_DASHBOARD_SHOULD_REFRESH:
      return genObj({ ...state, shouldRefresh: action.shouldRefresh });
    case TOGGLE_DASHBOARD_LOADING:
      return genObj({ ...state, loading: action.loading });
    default:
      return state;
  }
};
export default dashboard;
